module.exports = __webpack_public_path__ + "static/media/tick.b881fc95.svg";